import { BsBoxSeam, BsBell } from "react-icons/bs";
import { MdPermMedia } from "react-icons/md";
import { FaChartLine, FaPlus, FaBarcode, FaTag } from "react-icons/fa";

/**
 * Seller Sidebar Menu Configuration
 * Defines menu structure for seller role users
 */
export const getSellerMenus = (counts = {}) => {
  return [
    [
      "Dashboard",
      [
        {
          name: "Dashboard",
          route: "/seller/dashboard",
          icon: <FaChartLine />,
          permission: "view_notification",
        },
        // {
        //   name: "Notifications",
        //   route: "/seller/notifications",
        //   icon: <BsBell />,
        //   permission: "view_notification",
        //   count: counts?.notification_count,
        // },
        // {
        //   name: "Alerts",
        //   route: "/seller/admin-alerts",
        //   icon: <BsBell />,
        //   permission: "view_notification",
        //   count: counts?.admin_alert_count,
        // },
      ],
    ],
    [
      "Product Management",
      [
        {
          name: "Products",
          route: "/seller/products",
          icon: <BsBoxSeam />,
          permission: "view_product",
          count: counts?.product_count,
        },
        {
          name: "Add Product",
          route: "/seller/products/create",
          icon: <FaPlus />,
          permission: "add_product",
        },
        {
          name: "SKUs",
          route: "/seller/skus",
          icon: <FaBarcode />,
          permission: "view_sku",
          count: counts?.sku_count,
        },
        // Single SKU creation is temporarily disabled; import-only flow
        {
          name: "Media Library",
          route: "/seller/media",
          icon: <MdPermMedia />,
          permission: "view_media",
          count: counts?.media_count,
        },
        {
          name: "Brands",
          route: "/seller/brands",
          icon: <FaTag />,
          permission: "view_brand",
        },
      ],
    ],
  ];
};

/**
 * Get menu items based on user permissions
 * @param {string[]} permissions - User permissions array
 * @param {Object} counts - Count data for menu badges
 * @returns {Array} Filtered menu structure
 */
export const getFilteredSellerMenus = (permissions = [], counts = {}) => {
  const menus = getSellerMenus(counts);
  
  if (!permissions || permissions.length === 0) {
    return [];
  }

  let filteredMenus = [];
  
  menus.forEach((menu) => {
    const [sectionName, menuItems] = menu;
    // Always show Dashboard section for seller (routes still permission/role-guarded)
    if (sectionName === "Dashboard") {
      filteredMenus.push([sectionName, menuItems]);
      return;
    }
    const filtered = menuItems.filter((item) => permissions.includes(item.permission));
    if (filtered.length > 0) filteredMenus.push([sectionName, filtered]);
  });

  return filteredMenus;
};

export default getSellerMenus;
